import { render, staticRenderFns } from "./level-update-modal-footer.vue?vue&type=template&id=4c9f210e&scoped=true&"
import script from "./level-update-modal-footer.vue?vue&type=script&lang=ts&"
export * from "./level-update-modal-footer.vue?vue&type=script&lang=ts&"
import style0 from "./level-update-modal-footer.vue?vue&type=style&index=0&id=4c9f210e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c9f210e",
  null
  
)

export default component.exports